/**
 * Clear all user-specific data from localStorage
 * This includes:
 * - Theme preferences
 * - Column visibility settings
 * - Column order settings
 * - Column sizing settings
 * - Expert mode
 * - Deck draft state
 * - Any other user-specific localStorage items
 */
export function clearAllUserData(): void {
  try {
    // Get all localStorage keys
    const keys = Object.keys(localStorage);
    
    // List of known user-specific keys to remove
    const userSpecificKeys = [
      "theme",
      "expertMode",
      "deckDraftState",
    ];
    
    // Remove known user-specific keys
    for (const key of userSpecificKeys) {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.warn(`Failed to remove localStorage key "${key}":`, error);
      }
    }
    
    // Remove all table-related preferences (column visibility, order, sizing)
    // These keys follow patterns like:
    // - {prefix}-table-column-visibility
    // - {prefix}-table-column-order
    // - {prefix}-table-column-sizes
    for (const key of keys) {
      if (
        key.endsWith("-table-column-visibility") ||
        key.endsWith("-table-column-order") ||
        key.endsWith("-table-column-sizes")
      ) {
        try {
          localStorage.removeItem(key);
        } catch (error) {
          console.warn(`Failed to remove localStorage key "${key}":`, error);
        }
      }
    }
    
    // Note: We're not using localStorage.clear() because that would remove
    // any system-level keys that might be set by the browser or other extensions.
    // Instead, we selectively remove user-specific keys.
  } catch (error) {
    console.error("Error clearing user data from localStorage:", error);
    // Don't throw - we want to continue even if localStorage cleanup fails
  }
}










